var React = require('react');

function AddUser (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("ellipse",{"id":"XMLID_100_","fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"8","cy":"6.9","rx":"4","ry":"4","key":0}),React.createElement("path",{"id":"XMLID_46_","fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM15.2,14.1c0,0,0.4-3.3-1.2-3.3h-1.4c-0.6,0-0.7,0.3-0.8,0.4c-0.5,1-1.6,1.5-2.7,1.5H6.9c-1.1,0-2.3-0.5-2.7-1.5\n\t\tc-0.1-0.1-0.2-0.4-0.8-0.4H2c-1.6,0-1.2,3.3-1.2,3.3s1.3,0.8,7.2,0.8S15.2,14.1,15.2,14.1z","key":1}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"11.6","y1":"2.9","x2":"15.1","y2":"2.9","key":2}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"13.4","y1":"1.1","x2":"13.4","y2":"4.6","key":3})]));
}

AddUser.displayName = "AddUser";

AddUser.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = AddUser;

AddUser.default = AddUser;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/add_user.svg
// module id = ../icon/src/icons/add_user.svg
// module chunks = 0